import { InjectorService } from '@tencent/ioc';
import { UI_CONFIG } from '../../providers/param/registry-keys.js';
import { ParamRegistry } from '../../registries/param-registry.js';
import { PreHandlers } from '../../registries/pre-handler-registry.js';

/**
 * 获得当前操作对应的 UI Config
 *
 * @public
 * @decorator
 */
function UIConfig() {
    return ParamRegistry.decorate(UI_CONFIG);
}
PreHandlers.set(UI_CONFIG, ({ runner }) => {
    var _a;
    const { from, name } = runner.point;
    const service = InjectorService.get(from);
    const config = (_a = service.getUIConfig(name)) !== null && _a !== void 0 ? _a : { name };
    return config;
});

export { UIConfig };
//# sourceMappingURL=ui-config.js.map
